import { useCallback } from 'react'
import type { RouterInputs } from '@klear/ui/lib/trpc'
import { trpc } from '@klear/ui/lib/trpc'

export function useOrderMutations() {
  const createMutation = trpc.order.create.useMutation()

  const createOrder = useCallback(
    (input: RouterInputs['order']['create']) => createMutation.mutateAsync(input),
    [createMutation.mutateAsync]
  )

  return {
    createOrder,
    isCreating: createMutation.isPending
  }
}
